import * as React from "react";

function ComputerApplicationIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" id="laptop" {...props}>
      <path d="M104 94H24a4 4 0 0 1-4-4V29a4 4 0 0 1 4-4h80a4 4 0 0 1 4 4v61a4 4 0 0 1-4 4ZM24 29v61h80V29Z"></path>
      <path d="M30 35h68v47H30z"></path>
      <path d="M100 84H28V33h72zm-68-4h64V37H32zm83 24H13A11 11 0 0 1 2 93a3 3 0 0 1 3-3h118a3 3 0 0 1 3 3 11 11 0 0 1-11 11zM6.07 94a7 7 0 0 0 6.93 6h102a7 7 0 0 0 6.93-6z"></path>
      <path d="M56 92h16v5H56z"></path>
    </svg>
  );
}

export default ComputerApplicationIcon;
